import { useEffect, useMemo, useState } from "react";
import { useGetBB13ApplicationQuery } from "../redux/services/getBB13ApplicationStatus";
import { useAppSelector } from "../redux/hook";
import { StatusUpdateInterface } from "../models/interfaces/update-status.interface";
import { uniq } from "lodash";
import { BB13ApplicationStatusInterface } from "../models/interfaces/bb13ApplicationStatus.interface";
import config from "../config";

const useGetBB13ApplicationsByHDBRefs = (hdbRefList: string[], activeApplications: StatusUpdateInterface[]) => {
  const loginUser = useAppSelector((state) => state.auth.AuthenticationSlice.loginUser);
  const singpassToken = useAppSelector((state) => state.auth.AuthenticationSlice.singpassToken);
  const [applicationsData, setApplicationData] = useState<BB13ApplicationStatusInterface[]>([]);

  const activeApplicationHdbRefs = activeApplications.map((e) => e.hdb_ref);
  const combinedHdbRefs = uniq([...hdbRefList, ...activeApplicationHdbRefs]);

  const { data: bb13Applications } = useGetBB13ApplicationQuery(
    { uinfin: loginUser?.uinfin ?? "", singpass_token: singpassToken ?? "", hdb_ref: combinedHdbRefs },
    { skip: combinedHdbRefs.length <= 0 || !loginUser?.uinfin }
  );

  const localDebugBb13Applications = useMemo(() => { 
    return [];
  }, [])

  const filteredBb13Applications = useMemo(() => {
    const processingBb13Applications = !config.isLocalhost ? bb13Applications : localDebugBb13Applications;
    return processingBb13Applications?.filter((bb13Application) => {
        if(!activeApplicationHdbRefs.includes(bb13Application.hdb_ref)){
          return true;
        }
        return bb13Application.status === "6";
      }) ?? [];
  }, [bb13Applications, activeApplicationHdbRefs, localDebugBb13Applications])

  useEffect(() => {
    if (Array.isArray(filteredBb13Applications)) {
      setApplicationData(filteredBb13Applications);
    } else {
      setApplicationData([]);
    }
  }, [filteredBb13Applications]);

  return { applicationsData };
};

export default useGetBB13ApplicationsByHDBRefs;